import { RequestService } from "../../services/RequestService";
import { GET_PERFORMERS } from "../constants";

export const getPerformers = async profileId => {
  const response = await RequestService.get(GET_PERFORMERS + profileId, {
    params: {
      show_licensee: 1
    }
  });

  return response;
};
